import { ref } from 'vue';

import { searchFormLib } from '../lib';
import { searchFormConfig } from '../config';
import type {
  Route,
  RouteState,
  CabinClass,
  SearchFormInitialState,
  Passengers,
} from '../types';

// TODO: Perhaps, we need to move search form to @aviatakz
export function useSearchForm({
  initialRoutes,
  initialIsYouth,
  initialCabinClass,
  initialPassengersState,
}: SearchFormInitialState = {}) {
  const initialRoutesData = initialRoutes
    ? searchFormLib.buildInitialRoutes(initialRoutes)
    : [searchFormLib.createRoute()];

  const isYouth = ref(Boolean(initialIsYouth));
  const routes = ref(initialRoutesData);
  const cabinClass = ref<CabinClass>(
    initialCabinClass || searchFormConfig.DEFAULT_CABIN_CLASS,
  );
  const passengers = ref(
    initialPassengersState || searchFormConfig.DEFAULT_PASSENGERS_STATE,
  );

  function updateRoute(updatedRoute: RouteState) {
    routes.value = routes.value.map(route =>
      route.id === updatedRoute.id ? { ...route, ...updatedRoute } : route,
    );
  }

  function updateCabinClass(newCabinClass: CabinClass) {
    cabinClass.value = newCabinClass;
  }

  function updatePassengersState(newState: Passengers) {
    passengers.value = newState;
  }

  function setIsYouth(value: boolean) {
    isYouth.value = value;
  }

  const isNonNullRoute = (route: Partial<Route>): route is Route =>
    Boolean(route.arr && route.dep);

  const isValidRoutes = (
    routes: Array<Partial<Route>>,
  ): routes is Array<Route> => routes.every(isNonNullRoute);

  function mapSearchFormPayload() {
    if (isValidRoutes(routes.value)) {
      return searchFormLib.getSearchFormPayload({
        routes: routes.value,
        passengers: passengers.value,
        cabinClass: cabinClass.value,
        isYouth: isYouth.value,
      });
    }
  }

  return {
    routes,
    isYouth,
    cabinClass,
    passengers,
    updateRoute,
    setIsYouth,
    updateCabinClass,
    updatePassengersState,
    mapSearchFormPayload,
  };
}
